// extracted by css-extract-rspack-plugin
export default {"secondaryItemLabel":"ContactRessourcePicker_secondaryItemLabel__Zdqk8"};